
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import Routes from './common/client/components/Routes';

import App from './components/App';
import AppsPage from './pages/app/AppsPage';
import ArticlePage from './pages/article/ArticlePage';
import ArticlesPage from './pages/article/ArticlesPage';
import HomePage from './pages/home/HomePage';
import CreateAccountPage from './pages/auth/CreateAccountPage';
import EditAccountPage from './pages/auth/EditAccountPage';
import LoginPage from './pages/auth/LoginPage';
import LogoutPage from './pages/auth/LogoutPage';
import NoAccessPage from './pages/auth/NoAccessPage';
import ChangePasswordPage from './pages/auth/ChangePasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';

const routes = [
    {
        component: App,
        routes: [{
            path: '/',
            exact: true,
            component: HomePage
        }, {
            path: '/createAccount',
            component: CreateAccountPage
        }, {
            path: '/editAccount',
            component: EditAccountPage
        }, {
            path: '/changePassword',
            component: ChangePasswordPage
        }, {
            path: '/resetPassword',
            component: ResetPasswordPage
        }, {
            path: '/login',
            component: LoginPage
        }, {
            path: '/logout',
            component: LogoutPage
        }, {
            path: '/noaccess',
            component: NoAccessPage
        }, {
            path: '/articles',
            component: ArticlesPage
        }, {
            path: '/article/:name',
            component: ArticlePage
        }, {
            path: '/apps',
            component: AppsPage
        }]
    }
];

const AppRouter = () => {
    return (
        <BrowserRouter basename="/portal">
            <Routes routes={routes} />
        </BrowserRouter>
    );
}

export default AppRouter;
